import { render, staticRenderFns } from "./selectCustomer.vue?vue&type=template&id=980724c4&scoped=true"
import script from "./selectCustomer.vue?vue&type=script&lang=js"
export * from "./selectCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980724c4",
  null
  
)

export default component.exports